import NotificationStore from './stores/NotificationStore'

export default function({
  notifications,
  fetchStatus
} = {}) {
  if (!notifications) {
    return { notifications: [] }
  }

  return {
    dismiss: (n) => NotificationStore.delete(n),
    markRead,
    fetch: () => NotificationStore.fetchAll(),
    fetchStatus,
    notifications,
    count: notifications.length,
    unread: notifications.reduce(unreadCount, 0),
  }
}

function unreadCount(count, notification) {
  return notification.read ? count : count + 1
}

function markRead(notification) {
  NotificationStore.update(Object.assign({}, notification, {
    read: true
  }))
}



// WEBPACK FOOTER //
// ./packages/bridge-global-nav/src/notifications/NotificationData.js